import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { WorkoutService } from '../workout.service';
import { environment } from '../../../../../environments/environment';
import { IHaloDropDown } from 'src/app/core/halo-dropdown/halo-dropdown.interface';
import { paramListKeyService } from '../param-list-key-translate.service';
import { HaloLoaderService } from 'src/app/core/halo-loader/halo-loader.service';

@Component({
  selector: 'app-add-workout-detail',
  templateUrl: './add-workout-detail.component.html',
  styleUrls: ['./add-workout-detail.component.scss'],
})
export class AddWorkoutDetailComponent implements OnInit {
  @Input() selectionInfo: any;
  @Input() workoutObj: any;
  @Input() sourceFrom: any;
  @Input() triggerSaveCustomWorkout: boolean;
  formControls = {
    workOutName: {
      defaultValue: '',
      valid: true,
    },
    goalTypeControls: [],
    nonGoalTypeControls: [],
    intervalControls: [],
  };

  cardioParamDef: any;
  selectedGoalType: any;
  selectedGoalTypeDetails: any;
  haloWebCloudURL: string = environment.haloWebCloudBasePath;
  terrainType: number;
  mylesTreadEquipment: any;
  goalTypeList: any;
  terrainTypeLabel: any;
  terrainTypeList: any;
  selectedTerrainType: any;
  intervalMinArr = [] as any;
  intervalSecArr = [] as any;

  intervalSecArrForZeroMin = [] as any;
  intervalSecArrForOneMin = [] as any;

  selectedIntervalMin: string | number | null = null;
  selectedIntervalSec: string | number | null = null;
  intervalWorkoutType: string;
  intervalMigrosType = '0.0';
  intTypeModelId: any;
  intervalWorkoutParams = [] as any;
  intervalSelectedTypeControls = [] as any;

  powermillTerrainFlatIsSpeed: string;
  showPowermillTerrainFlatToggle = false;

  stepsOrFloors = 'steps';
  showPowermillGoalTypeClimbToggle = false;

  //  Preparing the payload by using workoutParamList and intervalParamlist.
  workoutParamList = [] as any;
  intervalParamList = [] as any;

  totalAppliedIntervalSec = 0;
  totalRemainingIntervalSec = 0;

  currentIntervalMin = 0;
  isAllowAddInterval = true;
  showUnsavedModal = false;
  showRemainingTimeModal = false;
  remainingTimeMessage: string;
  selectedToggleToReset: any;
  isEditWorkout = false;
  iconSaveImage = environment.cloudBasePath + '/Icons/ico_save.png';
  iconUndoImage = environment.cloudBasePath + '/Icons/ico_undo.png';
  consolesWithTitle = ['aquaman', 'superman', 'hal'];
  @Output() remainingTimeEventEmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() intervalParamListEventEmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() backToWorkoutTemplateListingEventEmit: EventEmitter<any> = new EventEmitter();
  @Output() backToWorkoutListingEventEmit: EventEmitter<any> = new EventEmitter();
  @Output() resetActionButtonEventEmit: EventEmitter<any> = new EventEmitter();

  constructor(
    private commonUtil: CommonUtil,
    private paramListKeyService: paramListKeyService,
    private workoutService: WorkoutService,
    private loader: HaloLoaderService
  ) {}

  ngOnInit(): void {
    this.totalRemainingIntervalSec = 0;
  }

  async ngOnChanges(changes: SimpleChanges) {
    if (changes.selectionInfo && changes.selectionInfo.currentValue !== changes.selectionInfo.previousValue) {
      this.mylesTreadEquipment = Number(changes.selectionInfo.currentValue.facility.summary.mylesTread);
    }

    if (changes.workoutObj && changes.workoutObj.currentValue !== changes.workoutObj.previousValue) {
      let workoutObj = changes.workoutObj.currentValue;
      if (workoutObj.facilityWorkoutId) {
        this.isEditWorkout = true;
      }
      if (this.selectionInfo.activityId && workoutObj.workoutId && this.selectionInfo.consoleType) {
        this.cardioParamDef = await this.loadGetCardioParamDef(
          this.selectionInfo.activityId,
          workoutObj.workoutId,
          this.selectionInfo.consoleType,
          this.selectionInfo.facility.facilityId
        );
        this.formControls = this.prepareFormControls();

        //Below to prepare GoalType Dropdown Option.Based on the goalTypeList is null , goal type option will be dropdown or input.
        if (this.formControls.goalTypeControls.length > 1) {
          this.goalTypeList = this.getGoalTypeList(this.formControls.goalTypeControls);
          this.selectedGoalType = this.goalTypeList[0];
        } else if (this.formControls.goalTypeControls.length === 1) {
          let controls: any = this.formControls.goalTypeControls[0];
          this.selectedGoalType = { value: Number(controls.paramId), text: '' };
        }

        let nonGoalTypes: any = this.formControls.nonGoalTypeControls.filter(
          (val: any) => Number(val.paramId) === 9 || Number(val.paramId) === 40 || Number(val.paramId) === 41
        );
        if (nonGoalTypes.length > 0) {
          if (
            (Number(this.workoutObj.workoutId) === 24 && Number(nonGoalTypes[0].paramId) === 9) ||
            (Number(this.workoutObj.workoutId) === 26 && Number(nonGoalTypes[0].paramId) === 9)
          ) {
          } else {
            this.terrainTypeLabel = this.getTerrainTypeLabelByParamId(nonGoalTypes[0].paramId);
            this.terrainTypeList = this.getTerrainTypeListByParamId(nonGoalTypes[0].paramId);
            this.selectedTerrainType = this.terrainTypeList[0];
          }
        }

        if (this.formControls.intervalControls.length > 0) {
          const intervalMin = this.prepareIntervalMin();
          const intervalSec = this.prepareIntervalSec();
          const intervalSecForZeromin = this.prepareIntervalSec('00');

          this.intervalMinArr = intervalMin;
          this.intervalSecArr = intervalSec;

          this.intervalSecArrForZeroMin = intervalSecForZeromin;
          this.intervalSecArrForOneMin = intervalSec;

          if (!this.isEditWorkout) {
            if (typeof this.cardioParamDef.intervals != 'undefined') {
              let intervalTypeList = JSON.parse(JSON.stringify(this.cardioParamDef.intervals));
              if (
                (this.selectionInfo.activityId == 18 ||
                  this.selectionInfo.activityId == 19 ||
                  this.selectionInfo.activityId == 4) &&
                intervalTypeList[0].intervalId == 19
              ) {
                intervalTypeList.splice(0, 1);
              }
              if (typeof intervalTypeList.length != 'undefined') {
                this.intervalWorkoutType = intervalTypeList[0].intervalId;
              } else {
                this.intervalWorkoutType = intervalTypeList.intervalId;
              }
            }
          } else {
            this.intervalWorkoutType = workoutObj.intervalId;
          }

          this.intervalWorkoutParams = this.prepareIntervalWorkoutParams();
          let temp = this.formControls.intervalControls.filter(
            (val: any) => val.intervalId === String(this.intervalWorkoutType)
          );
          this.intervalSelectedTypeControls = temp.filter(
            (control: any) =>
              control.isShowControl &&
              this.workoutObj.workoutId == 1005 &&
              Number(this.intervalWorkoutType) == 19 &&
              control.paramId == '14' &&
              control.intervalId == '19'
          );

          this.intervalParamListEventEmit.emit(this.intervalParamList);
        }

        if (
          workoutObj.workoutId == 18 ||
          workoutObj.workoutId == 19 ||
          workoutObj.workoutId == 20 ||
          workoutObj.workoutId == 1005 ||
          workoutObj.workoutId == 1011
        ) {
          let TimeGoalType: any;
          if (!this.isEditWorkout) {
            TimeGoalType = this.formControls.goalTypeControls.find((val: any) => val.paramId === '7');
          } else {
            TimeGoalType = workoutObj.workoutParamList.find((val: any) => val.paramId === '7');
          }

          let defaultMin = Number(this.isEditWorkout ? TimeGoalType.paramValue : TimeGoalType.defaultValue);
          let defaultSec = defaultMin * 60;
          this.currentIntervalMin = defaultMin;
          this.totalRemainingIntervalSec = defaultSec;
          this.isAllowAddInterval =
            this.totalRemainingIntervalSec -
              (Number(this.selectedIntervalMin) * 60 + Number(this.selectedIntervalSec)) >=
            0
              ? true
              : false;
          this.remainingTimeEventEmit.emit({
            totalRemainingIntervalSec: this.totalRemainingIntervalSec,
            totalAppliedIntervalSec: this.totalAppliedIntervalSec,
            formControls: this.formControls,
          });
        }

        // Load Form Control Value In Edit State.
        if (workoutObj.workoutParamList) {
          this.loader.startProcess();
          setTimeout(() => {
            this.loadFormControlValueInEditState();
            this.loader.endProcess();
          });
        }
      }
    }

    if (
      changes.triggerSaveCustomWorkout &&
      changes.triggerSaveCustomWorkout.currentValue !== changes.triggerSaveCustomWorkout.previousValue &&
      changes.triggerSaveCustomWorkout.currentValue === true &&
      changes.triggerSaveCustomWorkout.firstChange !== true
    ) {
      this.updateFormControlsvalidityStatus();
      if (
        this.formControls.workOutName.valid &&
        this.formControls.goalTypeControls.filter((val: any) => val.valid === false).length === 0 &&
        this.formControls.nonGoalTypeControls.filter((val: any) => val.valid === false).length === 0
      ) {
        this.loader.startProcess();
        this.saveCustomWorkout();
        this.loader.endProcess();
      }
    }
  }

  loadFormControlValueInEditState() {
    this.formControls.workOutName.defaultValue = this.workoutObj.workoutName;

    if (this.formControls.goalTypeControls.length > 0) {
      this.formControls.goalTypeControls.forEach((val: any) => {
        let workoutParamList = this.workoutObj.workoutParamList.find((data: any) => data.paramId === val.paramId);
        if (workoutParamList) {
          if (val.paramId === '21') {
            if (
              workoutParamList.hasOwnProperty('stepsOrFloors') ||
              workoutParamList.paramUnitName === 'Steps' ||
              workoutParamList.paramUnitName === 'Floors'
            ) {
              if (workoutParamList.stepsOrFloors === 'steps') {
                val.defaultValue =
                  workoutParamList.paramId !== '9' && workoutParamList.paramId !== '31'
                    ? Number(workoutParamList.paramValue)
                    : workoutParamList.paramValue;
                val.stepsOrFloors = 'steps';
                this.stepsOrFloors = 'steps';

                if (workoutParamList.goalTypeSelected === 'true') {
                  this.selectedGoalType = {
                    value: Number(workoutParamList.paramId),
                    text: 'Steps',
                  };
                }
              } else {
                val.floor_defaultValue =
                  workoutParamList.paramId !== '9' && workoutParamList.paramId !== '31'
                    ? Number(workoutParamList.paramValue)
                    : workoutParamList.paramValue;
                val.stepsOrFloors = 'floor';
                this.stepsOrFloors = 'floor';
                if (workoutParamList.goalTypeSelected === 'true') {
                  this.selectedGoalType = {
                    value: Number(workoutParamList.paramId),
                    text: 'Floors',
                  };
                }
              }
            } else {
              val.defaultValue =
                workoutParamList.paramId !== '9' && workoutParamList.paramId !== '31'
                  ? Number(workoutParamList.paramValue)
                  : workoutParamList.paramValue;
              this.selectedGoalType = { value: Number(workoutParamList.paramId), text: '' };
            }
          } else {
            val.defaultValue =
              workoutParamList.paramId !== '9' && workoutParamList.paramId !== '31'
                ? Number(workoutParamList.paramValue)
                : workoutParamList.paramValue;
            this.selectedGoalType = { value: Number(workoutParamList.paramId), text: '' };
          }
        }
      });
    }
    if (this.formControls.nonGoalTypeControls.length > 0) {
      this.formControls.nonGoalTypeControls.forEach((val: any) => {
        let workoutParamList: any;
        if (val.hasOwnProperty('isHighVoltage')) {
          workoutParamList = this.workoutObj.workoutParamList.find(
            (data: any) => data.paramId === val.paramId && data.isHighVoltage === val.isHighVoltage
          );
        } else {
          workoutParamList = this.workoutObj.workoutParamList.find((data: any) => data.paramId === val.paramId);
        }

        if (workoutParamList) {
          val.defaultValue =
            workoutParamList.paramId !== '9' && workoutParamList.paramId !== '31'
              ? Number(workoutParamList.paramValue)
              : workoutParamList.paramValue;
          if (workoutParamList.paramId == '19') {
            val.defaultValue = this.secondsToTime(val.defaultValue);
          }
          if (workoutParamList.paramId === '40' || workoutParamList.paramId === '41') {
            this.selectedTerrainType = { value: Number(workoutParamList.paramValue), text: '' };
          }
        }
      });

      if (!this.isSe4Console() &&
        this.selectedTerrainType &&
        Number(this.selectedTerrainType.value) === 1 &&
        Number(this.workoutObj.activityId) === 16 &&
        (Number(this.workoutObj.workoutId) === 1001 ||
          Number(this.workoutObj.workoutId) === 1003 ||
          Number(this.workoutObj.workoutId) === 1006)
      ) {
        if (this.workoutObj.workoutParamList.findIndex((val: any) => val.paramId === '12') > -1) {
          this.powermillTerrainFlatIsSpeed = '12';
          this.powermillTerrainControlPrepare(this.powermillTerrainFlatIsSpeed);
        }
        if (this.workoutObj.workoutParamList.findIndex((val: any) => val.paramId === '14') > -1) {
          this.powermillTerrainFlatIsSpeed = '14';
          this.powermillTerrainControlPrepare(this.powermillTerrainFlatIsSpeed);
        }
      }
    }

    if (this.formControls.intervalControls.length > 0) {
      let intervalList = [] as any;
      this.workoutObj.workoutParamList
        .filter((val: any) => val.paramIntervalInfo)
        .forEach((ele: any) => {
          ele.paramIntervalInfo.forEach((item: any) => {
            item.paramId = ele.paramId;
            intervalList.push(item);
          });
        });
      let intervalBasedTableData = this.uniqueByKey(intervalList, 'intervalNo').map((val: any) => val.intervalNo);
      this.intervalParamList = [];
      intervalBasedTableData.forEach((val: any) => {
        let duration = Number(intervalList.find((item: any) => item.intervalNo === val).duration);

        let selectedIntervalMin =
          parseInt(String(duration / 60)).toString().length === 1
            ? '0' + parseInt(String(duration / 60)).toString()
            : parseInt(String(duration / 60)).toString();
        let selectedIntervalSec =
          (duration % 60).toString().length === 1 ? '0' + (duration % 60).toString() : (duration % 60).toString();
        let intervalWorkoutParamsObj = JSON.parse(JSON.stringify(this.intervalWorkoutParams));
        intervalWorkoutParamsObj.forEach((tmp: any) => {
          let subTemp = intervalList.find((c: any) => c.intervalNo === val && c.paramId === tmp.paramId);
          tmp.defaultValue = subTemp.value;
        });

        let obj = {
          intervalMinArr: this.intervalMinArr,
          intervalSecArr: this.intervalSecArr,
          selectedIntervalMin: selectedIntervalMin,
          selectedIntervalSec: selectedIntervalSec,
          paramIntervalInfo: intervalWorkoutParamsObj,
          isEdited: false,
          valid: true,
        } as any;
        obj.paramIntervalInfo = this.updateSpeedInclineCompareChart(obj.paramIntervalInfo);
        obj['previousIntervalInfo'] = JSON.parse(JSON.stringify(obj));
        this.intervalParamList.push(obj);
      });

      this.updateRemainingInterval();
      if (this.intervalSelectedTypeControls.length > 0) {
        this.intervalSelectedTypeControls.forEach((element: any) => {
          let info = this.workoutObj.workoutParamList.find((cVal: any) => cVal.paramId === element.paramId);
          if (info) {
            element.defaultValue = info.paramValue;
          }
        });
      }
      this.intervalParamListEventEmit.emit(this.intervalParamList);
    }
  }

  async saveCustomWorkout() {
    if (
      (this.workoutObj.workoutId == 18 ||
        this.workoutObj.workoutId == 19 ||
        this.workoutObj.workoutId == 20 ||
        this.workoutObj.workoutId == 1005) &&
      this.totalRemainingIntervalSec !== 0
    ) {
      let minutes = Math.floor(this.totalRemainingIntervalSec / 60);
      let seconds = this.totalRemainingIntervalSec - minutes * 60;
      let remainingTimeValue = '<b>' + minutes + ' Min ' + seconds + ' Sec' + '</b>' + '<br/><br/>';
      let message = this.commonUtil.replaceValueAsHTMLOnTranslatedText('REMAINING.TIME.IS', [remainingTimeValue]);
      let unassingedMessage = this.commonUtil.translateText('REMAINING.TIME.UNASSIGNED.MESSAGE');
      message = message + unassingedMessage;
      this.remainingTimeMessage = message;
      this.showRemainingTimeModal = true;
    } else {
      let payload = this.preparePayload();
      try {
        this.loader.startProcess();
        let resp: any = await this.workoutService.saveWorkOut(payload);
        this.loader.endProcess();
        if (this.isEditWorkout && this.sourceFrom === 'workoutTemplate') {
          this.backToWorkoutTemplateListingEventEmit.emit({
            ...payload,
            facilityWorkoutId: this.workoutObj.facilityWorkoutId,
          });
        } else {
          this.backToWorkoutListingEventEmit.emit();
        }
      } catch (error) {
        console.log('---api error--', error);
      }
    }
  }

  preparePayload() {
    let obj: any;
    //Prepare payload for interval workout.
    if (
      Number(this.workoutObj.workoutId) == 18 ||
      Number(this.workoutObj.workoutId) == 19 ||
      Number(this.workoutObj.workoutId) == 20 ||
      Number(this.workoutObj.workoutId) == 1005 ||
      Number(this.workoutObj.workoutId) == 1011
    ) {
      obj = {
        activityId: Number(this.selectionInfo.activityId),
        consoleType: this.selectionInfo.consoleType,
        intervalId: this.intervalWorkoutType,
        workoutId: this.workoutObj.workoutId.toString(),
        workoutName: this.formControls.workOutName.defaultValue,
        workoutParamList: [],
      };

      if (
        this.workoutObj.workoutId == 1005 &&
        Number(this.selectionInfo.activityId) == 28 &&
        Number(this.intervalWorkoutType) == 18
      ) {
        obj.modelId = this.intTypeModelId;
      }

      if (this.selectionInfo.consoleType === 'discover' && this.selectionInfo.categoryId) {
        obj.categoryId = this.selectionInfo.categoryId;
      }

      if (this.consolesWithTitle.indexOf(this.selectionInfo.consoleType) > -1) {
        if (this.workoutObj.workoutId == 1005) {
          obj.intervalId = this.intervalWorkoutType;
        }
        if (this.workoutObj.workoutId == 1011) {
          obj.intervalId = 0;
        }
      }

      if (this.isEditWorkout) {
        obj['id'] = this.workoutObj.facilityWorkoutId;
      }

      if (this.formControls.goalTypeControls.length > 0) {
        let goalType = this.formControls.goalTypeControls[0] as any;
        obj.workoutParamList.push({
          goalTypeSelected: goalType.isGoalType,
          paramId: goalType.paramId,
          paramValue: Number(goalType.defaultValue),
        });
      }

      if (this.formControls.nonGoalTypeControls.length > 0) {
        this.formControls.nonGoalTypeControls.forEach((val: any) => {
          if (val.isShowControl) {
            let paramValue = String(val.defaultValue);
            if (val.paramId === 19) {
              paramValue = this.timeToSeconds(val.paramValue).toString();
            }
            let jsonObj = {
              paramId: val.paramId,
              paramValue: paramValue,
            } as any;
            if (val.hasOwnProperty('isHighVoltage')) {
              jsonObj.isHighVoltage = val.isHighVoltage;
            }
            if (val.paramValues) {
              jsonObj.paramValues = val.paramValues;
            }

            obj.workoutParamList.push(jsonObj);
          } else {
            /*Including additional param as per angular.js payload requirement*/
            if (['discover'].includes(this.selectionInfo.consoleType)) {
              if ([18, 19, 20].includes(Number(this.workoutObj.workoutId))) {
                if ([1].includes(Number(val.paramId))) {
                  let jsonObj = this.prepareWorkOutParam(val);
                  obj.workoutParamList.push(jsonObj);
                }
              }

              if ([2].includes(Number(val.paramId))) {
                let jsonObj = this.prepareWorkOutParam(val);
                obj.workoutParamList.push(jsonObj);
              }
            }
          }
        });
      }

      //Prepare Interval From Grid Table.
      if (this.intervalParamList.length > 0) {
        this.intervalWorkoutParams.forEach((element: any) => {
          let preparedParamIntervalInfo = this.prepareParamIntervalInfo(element.paramId);
          let totalInclineOrSpeed = parseFloat(
            preparedParamIntervalInfo.map((tmp: any) => Number(tmp.value)).reduce((a: any, b: any) => a + b)
          );
          let totalintervalcount = preparedParamIntervalInfo.length;
          let tmp: any = {
            intervalId: element.intervalId,
            paramId: element.paramId,
            paramIntervalInfo: preparedParamIntervalInfo,
            paramValue: totalInclineOrSpeed / totalintervalcount,
          };

          if (element.hasOwnProperty('isHighVoltage')) {
            tmp.isHighVoltage = element.isHighVoltage;
          }

          if (Number(this.workoutObj.workoutId) != 1011) {
            tmp['step'] = element.step;
          }

          obj.workoutParamList.push(tmp);
        });
      }

      //Prepare Interval Selected Control that wasn't included in data grid table.
      if (this.intervalSelectedTypeControls.length > 0) {
        this.intervalSelectedTypeControls.forEach((val: any) => {
          let tmpObj = {
            paramId: val.paramId,
            paramUnitName: val.unitName.userPreferredLanguage,
            paramValue: String(val.defaultValue),
          } as any;
          if (val.intervalId) {
            tmpObj['intervalId'] = val.intervalId;
          }
          obj.workoutParamList.push(tmpObj);
        });
      }

      /*Including additional param for interval workout as per angular.js payload requirement*/
      if (
        ['discover'].includes(this.selectionInfo.consoleType) &&
        [18, 19, 20].includes(Number(this.workoutObj.workoutId))
      ) {
        const intervalWorkoutList = this.formControls.intervalControls.filter((val: any) => !val.isShowControl); // Adding missing param for interval for discover console.
        intervalWorkoutList.forEach((val: any) => {
          if (Number(this.workoutObj.activityId) === 2) {
            // Bike Workout , discover console.Adding 1 as additional parmeter if exist.
            if ([1].includes(Number(val.paramId))) {
              let tmpObj = {
                paramId: val.paramId,
                paramUnitName: val.unitName.userPreferredLanguage,
                paramValue: String(val.defaultValue),
              } as any;
              if (val.intervalId) {
                tmpObj['intervalId'] = val.intervalId;
              }
              obj.workoutParamList.push(tmpObj);
            }
          }

          if ([2].includes(Number(val.paramId))) {
            let tmpObj = {
              paramId: val.paramId,
              paramUnitName: val.unitName.userPreferredLanguage,
              paramValue: String(val.defaultValue),
            } as any;
            if (val.intervalId) {
              tmpObj['intervalId'] = val.intervalId;
            }
            obj.workoutParamList.push(tmpObj);
          }
        });
      }

      return obj;
    } else if (Number(this.workoutObj.workoutId) == 34) {
      obj = {
        activityId: Number(this.selectionInfo.activityId),
        consoleType: this.selectionInfo.consoleType,
        workoutId: this.workoutObj.workoutId.toString(),
        workoutName: this.formControls.workOutName.defaultValue,
        workoutParamList: [],
      };
      if (this.selectionInfo.consoleType === 'discover' && this.selectionInfo.categoryId) {
        obj.categoryId = this.selectionInfo.categoryId;
      }

      if (this.isEditWorkout) {
        obj['id'] = this.workoutObj.facilityWorkoutId;
      }
      let cTest = this.cardioParamDef.cardioParamDef;
      if (cTest.length > 0) {
        cTest.forEach((val: any) => {
          let jsonObj = {
            paramId: val.paramId,
            paramValue: String(val.defaultValue),
            paramUnitName: val.unitName.userPreferredLanguage,
          } as any;
          obj.workoutParamList.push(jsonObj);
        });
      }
      return obj;
    } else {
      //Prepare payload for other workout.
      obj = {
        activityId: Number(this.selectionInfo.activityId),
        consoleType: this.selectionInfo.consoleType,
        workoutId: this.workoutObj.workoutId.toString(),
        workoutName: this.formControls.workOutName.defaultValue,
        workoutParamList: [],
      };

      if (this.selectionInfo.consoleType === 'discover' && this.selectionInfo.categoryId) {
        obj.categoryId = this.selectionInfo.categoryId;
      }

      if (this.isEditWorkout) {
        obj['id'] = this.workoutObj.facilityWorkoutId;
      }

      if (this.formControls.goalTypeControls.length > 0) {
        let goalType: any;
        goalType = this.selectedGoalTypeDetails ? this.selectedGoalTypeDetails : this.formControls.goalTypeControls[0];
        if (goalType.paramId === '21') {
          if (goalType.hasOwnProperty('stepsOrFloors')) {
            obj.workoutParamList.push({
              goalTypeSelected: goalType.isGoalType,
              paramId: goalType.paramId,
              paramValue:
                goalType.stepsOrFloors === 'steps'
                  ? Number(goalType.defaultValue)
                  : Number(goalType.floor_defaultValue),
              paramUnitName: '',
              stepsOrFloors: goalType.stepsOrFloors,
            });
          } else {
            obj.workoutParamList.push({
              goalTypeSelected: goalType.isGoalType,
              paramId: goalType.paramId,
              paramValue: String(goalType.defaultValue),
              paramUnitName: goalType.unitName.userPreferredLanguage,
            });
          }
        } else {
          obj.workoutParamList.push({
            goalTypeSelected: goalType.isGoalType,
            paramId: goalType.paramId,
            paramValue: String(goalType.defaultValue),
            paramUnitName: goalType.unitName.userPreferredLanguage,
          });
        }
      }

      if (this.formControls.nonGoalTypeControls.length > 0) {
        this.formControls.nonGoalTypeControls.forEach((val: any) => {
          if (val.isShowControl) {
            let jsonObj = this.prepareWorkOutParam(val);
            obj.workoutParamList.push(jsonObj);
          } else {
            const consoleTypes = ['discover'];
            /*Including additional param as per angular.js payload requirement*/
            if (consoleTypes.includes(this.selectionInfo.consoleType)) {
              if ([2, 4, 7, 8, 9].includes(Number(this.workoutObj.workoutId)) && [1].includes(Number(val.paramId))) {
                let jsonObj = this.prepareWorkOutParam(val);
                obj.workoutParamList.push(jsonObj);
              }
              if (
                [22, 23, 24, 25, 32, 60].includes(Number(this.workoutObj.workoutId)) &&
                [1, 3].includes(Number(val.paramId))
              ) {
                let jsonObj = this.prepareWorkOutParam(val);
                obj.workoutParamList.push(jsonObj);
              }

              if ([26].includes(Number(this.workoutObj.workoutId)) && [3].includes(Number(val.paramId))) {
                let jsonObj = this.prepareWorkOutParam(val);
                obj.workoutParamList.push(jsonObj);
              }

              if (
                [14, 29, 31].includes(Number(this.workoutObj.workoutId)) &&
                Number(this.workoutObj.activityId) === 2 &&
                [1].includes(Number(val.paramId))
              ) {
                let jsonObj = this.prepareWorkOutParam(val);
                obj.workoutParamList.push(jsonObj);
              }

              if ([2].includes(Number(val.paramId))) {
                let jsonObj = this.prepareWorkOutParam(val);
                obj.workoutParamList.push(jsonObj);
              }
            }
          }
        });
      }
      return obj;
    }
  }

  prepareWorkOutParam(val: any) {
    let paramValue = String(val.defaultValue);
    if (val.paramId === 19) {
      paramValue = this.timeToSeconds(val.paramValue).toString();
    }
    let jsonObj = {
      paramId: val.paramId,
      paramValue: paramValue,
    } as any;
    if (val.hasOwnProperty('isHighVoltage')) {
      jsonObj.isHighVoltage = val.isHighVoltage;
    }
    if (val.paramValues) {
      jsonObj.paramValues = val.paramValues;
    }
    return jsonObj;
  }

  prepareParamIntervalInfo(paramId: string) {
    let paramIntervalInfo = [] as any;
    this.intervalParamList.forEach((element: any, index: number) => {
      paramIntervalInfo.push({
        intervalNo: index + 1,
        duration: Number(element.selectedIntervalMin * 60) + Number(element.selectedIntervalSec),
        value: Number(element.paramIntervalInfo.find((val: any) => val.paramId === paramId).defaultValue),
      });
    });
    return paramIntervalInfo;
  }

  updateFormControlsvalidityStatus() {
    if (!this.formControls.workOutName.defaultValue || /[<>?/\|:]/.test(this.formControls.workOutName.defaultValue)) {
      this.formControls.workOutName.valid = false;
    } else {
      this.formControls.workOutName.valid = true;
    }

    this.formControls.goalTypeControls.forEach((element: any) => {
      if (element.isShowControl) {
        element.valid = this.validateInputRange(element);
      }
    });

    this.formControls.nonGoalTypeControls.forEach((element: any) => {
      if (element.isShowControl) {
        element.valid = this.validateInputRange(element);
      }
    });
  }

  validateInputRange(element: any) {
    let status = false;
    if (element.defaultValue !== '' && element.defaultValue !== null) {
      if (element.paramId === '21') {
        if (element.stepsOrFloors === 'steps') {
          if (element.hasOwnProperty('minValue') && element.hasOwnProperty('maxValue')) {
            if (element.defaultValue >= element.minValue && element.defaultValue <= element.maxValue) {
              status = true;
            }
          } else {
            status = true;
          }
        } else if (element.stepsOrFloors === 'floor') {
          if (element.hasOwnProperty('floor_minValue') && element.hasOwnProperty('floor_maxValue')) {
            if (
              element.floor_defaultValue >= element.floor_minValue &&
              element.floor_defaultValue <= element.floor_maxValue
            ) {
              status = true;
            }
          } else {
            status = true;
          }
        } else {
          if (element.hasOwnProperty('minValue') && element.hasOwnProperty('maxValue')) {
            if (element.defaultValue >= element.minValue && element.defaultValue <= element.maxValue) {
              status = true;
            }
          } else {
            status = true;
          }
        }
      } else {
        let paceOldvalue: string = '';
        if (element.paramId == 19) {
          paceOldvalue = element.defaultValue;
          element.defaultValue = this.timeToSeconds(element.defaultValue);
        }
        if (element.hasOwnProperty('minValue') && element.hasOwnProperty('maxValue')) {
          if (element.defaultValue >= element.minValue && element.defaultValue <= element.maxValue) {
            status = true;
          } else {
            status = false;
          }
        } else {
          status = true;
        }
        if (status == false && element.paramId == 19) {
          element.defaultValue = paceOldvalue;
        }
      }
    }
    return status;
  }

  loadGetCardioParamDef(activityId: number, workoutId: string, consoleType: string, facilityId: string) {
    return this.workoutService.getCardioParamDef(activityId, workoutId, consoleType, facilityId);
  }

  prepareGoalTypeControls() {
    return this.cardioParamDef.cardioParamDef.filter((val: any) => val.isGoalType === 'true');
  }

  prepareNonGoalTypControls() {
    if (
      this.workoutObj.workoutId === '1005' ||
      this.workoutObj.workoutId === '1011' ||
      this.workoutObj.workoutId === '18' ||
      this.workoutObj.workoutId === '20'
    ) {
      return [];
    } else if (this.workoutObj.workoutId === '19') {
      return this.cardioParamDef.cardioParamDef.filter(
        (val: any) => val.isGoalType === 'false' && val.paramId === '14'
      );
    }
    return this.cardioParamDef.cardioParamDef.filter((val: any) => val.isGoalType === 'false');
  }

  prepareIntervalControls() {
    if (
      this.workoutObj.workoutId === '1005' ||
      this.workoutObj.workoutId === '1011' ||
      this.workoutObj.workoutId === '18' ||
      this.workoutObj.workoutId === '20'
    ) {
      return this.cardioParamDef.cardioParamDef.filter((val: any) => val.isGoalType === 'false');
    } else if (this.workoutObj.workoutId === '19') {
      return this.cardioParamDef.cardioParamDef.filter(
        (val: any) => val.isGoalType === 'false' && val.paramId !== '14'
      );
    }
    return [];
  }

  prepareFormControls() {
    let controls = {
      workOutName: {
        defaultValue: this.workoutService.getEquipmentDisplayNameByEquipmentTypeId(this.selectionInfo.activityId),
        valid: true,
      },
      goalTypeControls: this.prepareGoalTypeControls(),
      nonGoalTypeControls: this.prepareNonGoalTypControls(),
      intervalControls: this.prepareIntervalControls(),
      selectedIntervalControls: [],
    };

    controls.goalTypeControls.forEach((element: any) => {
      if (element.minValue && element.maxValue) {
        element.minValue = Number(element.minValue);
        element.maxValue = Number(element.maxValue);
      }
      if (
        element.paramId === '21' &&
        (this.workoutObj.workoutId === '1' ||
          this.workoutObj.workoutId === '2' ||
          this.workoutObj.workoutId === '3' ||
          this.workoutObj.workoutId === '4' ||
          this.workoutObj.workoutId === '5' ||
          this.workoutObj.workoutId === '7' ||
          this.workoutObj.workoutId === '8' ||
          this.workoutObj.workoutId === '1004' ||
          this.workoutObj.workoutId === '1006')
      ) {
        if (this.selectionInfo.activityId == 16) {
          element.unitName = {
            applicationDefaultLanguage: '',
            clubDefaultLanguage: '',
            userPreferredLanguage: 'Steps',
          };
          element.stepsOrFloors = 'steps';

          const floorDefaultValue = this.stepsAndFloorConversionDefaultValue('floor', element);
          const floorMinMaxValue = this.getMinMaxValueByStepsAndFloor('floor', element);

          (element.floor_defaultValue = floorDefaultValue),
            (element.floor_maxValue = floorMinMaxValue.maxValue),
            (element.floor_minValue = floorMinMaxValue.minValue),
            (element.floor_unitName = {
              applicationDefaultLanguage: '',
              clubDefaultLanguage: '',
              userPreferredLanguage: 'Floors',
            });
        }
      }
      element.valid = true;
      element.defaultValue =
        element.paramId !== '9' && element.paramId !== '31' ? Number(element.defaultValue) : element.defaultValue;
      element.isShowControl = true;
    });

    controls.nonGoalTypeControls.forEach((element: any) => {
      if (element.minValue && element.maxValue) {
        element.minValue = Number(element.minValue);
        element.maxValue = Number(element.maxValue);
      }
      element.valid = true;
      element.defaultValue =
        element.paramId !== '9' && element.paramId !== '31' ? Number(element.defaultValue) : element.defaultValue;
      if (element.paramId == '19') {
        element.defaultValue = this.secondsToTime(Number(element.defaultValue));
      }
      element.isShowControl = this.showControls(element);
    });

    controls.intervalControls.forEach((element: any) => {
      if (element.minValue && element.maxValue) {
        element.minValue = Number(element.minValue);
        element.maxValue = Number(element.maxValue);
      }
      element.valid = true;
      element.defaultValue =
        element.paramId !== '9' && element.paramId !== '31' ? Number(element.defaultValue) : element.defaultValue;
      element.isShowControl = this.showThisField(element);
    });

    return controls;
  }

  showControls(control: any) {
    let showThisFieldConditionCheckOne = false;
    let showThisFieldConditionCheckTwo = false;
    let status = false;
    if (
      this.showThisField(control) &&
      Number(this.workoutObj.workoutId) == 1006 &&
      Number(this.terrainType) == 1 &&
      (Number(this.selectionInfo.activityId) == 1 || Number(this.selectionInfo.activityId) == 28) &&
      Number(control.paramId) == 11
    ) {
      status = true;
    } else {
      showThisFieldConditionCheckOne =
        this.showThisField(control) &&
        Number(this.workoutObj.workoutId) != 1005 &&
        !(
          (Number(this.selectionInfo.activityId) == 1 || Number(this.selectionInfo.activityId) == 28) &&
          Number(control.paramId) == 11 &&
          Number(this.workoutObj.workoutId) == 1006
        );
      showThisFieldConditionCheckTwo = this.ngHideConditionCheck(control);
      // console.log('--control--',control);
      // console.log('--showThisFieldConditionCheckOne--',showThisFieldConditionCheckOne);
      // console.log('--showThisFieldConditionCheckTwo HideCondition--',showThisFieldConditionCheckTwo);
      status = showThisFieldConditionCheckOne === true && showThisFieldConditionCheckTwo === true ? true : false;
    }

    return status;
  }

  showThisField(control: any) {
    //Show pace related fields only to the goal type "Pace".
    if (typeof this.selectedGoalTypeDetails != 'undefined' && this.selectedGoalTypeDetails == 'true') {
      if (
        Number(this.selectedGoalTypeDetails.paramId) == 6 ||
        (Number(this.selectedGoalTypeDetails.paramId) != 6 &&
          Number(control.paramId) != 19 &&
          Number(control.paramId) != 20)
      ) {
        return true;
      } else if (Number(control.paramId) == 19 || Number(control.paramId) == 20) {
        return false;
      }
    } else {
      if (
        Number(control.paramId) == 1 ||
        Number(control.paramId) == 2 ||
        Number(control.paramId) == 3 ||
        Number(control.paramId) == 10 ||
        Number(control.paramId) == 18 ||
        Number(control.paramId) == 22 ||
        Number(control.paramId) == 23 ||
        Number(control.paramId) == 26 ||
        Number(control.paramId) == 27 ||
        Number(control.paramId) == 28 ||
        Number(control.paramId) == 29 ||
        Number(control.paramId) == 30
      ) {
        return false;
      }
      if (
        (typeof this.selectedGoalTypeDetails == 'undefined' || Number(this.selectedGoalTypeDetails.paramId) != 6) &&
        (Number(control.paramId) == 19 || Number(control.paramId) == 20)
      ) {
        return false;
      }
      if (
        Number(this.workoutObj.workoutId) === 1005 &&
        this.mylesTreadEquipment === 0 &&
        Number(this.selectionInfo.activityId) === 28 &&
        Number(control.paramId) === 14 &&
        control.hasOwnProperty('isHighVoltage')
      ) {
        return false;
      }
      if (
        Number(this.workoutObj.workoutId) === 1005 &&
        this.mylesTreadEquipment === 1 &&
        Number(this.selectionInfo.activityId) === 28 &&
        Number(control.paramId) === 14 &&
        !control.hasOwnProperty('isHighVoltage')
      ) {
        return false;
      }
      return true;
    }
    return false;
  }

  ngHideConditionCheck(control: any) {
    if (
      Number(this.selectionInfo.activityId) == 16 &&
      Number(control.paramId) == 14 &&
      (Number(this.workoutObj.workoutId) == 1 || Number(this.workoutObj.workoutId) == 32)
    ) {
      return true;
    } else {
      let status =
        (Number(this.terrainType) == 1 &&
          (Number(this.selectionInfo.activityId) == 1 || Number(this.selectionInfo.activityId) == 28) &&
          Number(control.paramId) == 12) ||
        (Number(this.workoutObj.workoutId) == 1004 &&
          Number(this.terrainType) != 1 &&
          (Number(this.selectionInfo.activityId) == 1 || Number(this.selectionInfo.activityId) == 28) &&
          Number(control.paramId) == 11) ||
        (Number(this.terrainType) != 1 &&
          Number(this.selectionInfo.activityId) == 16 &&
          Number(control.paramId) == 14) ||
        (Number(this.terrainType) == 1 &&
          Number(this.selectionInfo.activityId) == 16 &&
          Number(control.paramId) == 12 &&
          Number(this.workoutObj.workoutId) != 1001 &&
          Number(this.workoutObj.workoutId) != 1004 &&
          Number(this.workoutObj.workoutId) != 1006) ||
        (Number(this.terrainType) == 1 &&
          Number(this.selectionInfo.activityId) == 16 &&
          Number(control.paramId) == 14 &&
          Number(this.workoutObj.workoutId) != 1001) ||
        (Number(this.terrainType) != 1 &&
          Number(this.selectionInfo.activityId) == 16 &&
          Number(control.paramId) == 14) ||
        (Number(this.selectionInfo.activityId) == 1 &&
          Number(control.paramId) == 11 &&
          Number(this.workoutObj.workoutId) == 1006) ||
        (Number(this.selectionInfo.activityId) == 28 &&
          Number(control.paramId) == 11 &&
          Number(this.workoutObj.workoutId) == 1006) ||
        (Number(this.selectionInfo.activityId) == 28 &&
          Number(control.paramId) == 14 &&
          !control.isHighVoltage &&
          Number(this.mylesTreadEquipment) == 1) ||
        (Number(this.selectionInfo.activityId) == 28 &&
          Number(control.paramId) == 14 &&
          control.isHighVoltage &&
          Number(this.mylesTreadEquipment) == 0);
      return !status;
    }
  }

  getGoalTypeList(goalTypeControls: any) {
    let list = [] as any;
    goalTypeControls.forEach((element: any) => {
      let paramListKey = this.paramListKeyService.getTranslateKeyByParamListkey(element.paramId);
      if (
        (Number(this.workoutObj.workoutId) === 1004 || Number(this.workoutObj.workoutId) === 1006) &&
        Number(element.paramId) === 21
      ) {
        paramListKey = 'CLIMB';
      }
      list.push({ value: Number(element.paramId), text: this.commonUtil.translateText(paramListKey) });
    });
    return list;
  }

  getTerrainTypeLabelByParamId(paramId: any) {
    if (Number(paramId) === 41) {
      return 'WORKOUT';
    } else {
      return 'TERRAIN';
    }
  }

  getTerrainTypeListByParamId(paramId: any) {
    if (Number(paramId) === 9) {
      return [
        { value: 0, text: this.commonUtil.translateText('LESS.THAN.5000FT') },
        { value: 1, text: this.commonUtil.translateText('MORE.THAN.5000FT') },
      ];
    } else if (Number(paramId) === 40) {
      let list: any = [
        { value: 1, text: this.commonUtil.translateText('FLAT') },
        { value: 2, text: this.commonUtil.translateText('RANDOM') },
        {
          value: 3,
          text: this.isSe4Console()
            ? this.commonUtil.translateText('HILLS.INTERVAL')
            : this.commonUtil.translateText('HILLS'),
        },
        { value: 4, text: this.commonUtil.translateText('ROLLING.HILLS') },
      ];
      if (this.isSe4Console() && this.selectionInfo.activityId != 19) {
        list.push({ value: 5, text: this.commonUtil.translateText('KILIMANJARO') });
      }
      return list;
    } else if (Number(paramId) === 41) {
      let list = [
        { value: 1, text: this.commonUtil.translateText('MODERATE.BURN') },
        { value: 2, text: this.commonUtil.translateText('VIGOROUS.BURN') },
      ];

      const consoles = ['hal', 'falco', 'neo_se4', 'everest'];

      if (!consoles.some((c) => this.selectionInfo.consoleType.includes(c))) {
        list.push({ value: 3, text: this.commonUtil.translateText('FIXED.TIME') });
        if (
          this.selectionInfo.activityId == 1 ||
          this.selectionInfo.activityId == 28 ||
          this.selectionInfo.activityId == 16
        ) {
          list.push({ value: 4, text: this.commonUtil.translateText('VARIOUS.TIME') });
        }
      }

      return list;
    }

    return [];
  }

  isSe4Console() {
    let status = false;
    const consoles = ['hal', 'everest', 'falco', 'neo_se4'];
    if (consoles.some((c) => this.selectionInfo.consoleType.includes(c))) {
      status = true;
    }
    return status;
  }

  uniqueByKey(array: any, key: any) {
    return [...new Map(array.map((x: any) => [x[key], x])).values()];
  }

  convertFloatToInteger(paramObj: any) {
    if (this.isInteger(paramObj.paramId)) {
      paramObj.defaultValue = parseInt(paramObj.defaultValue);
      paramObj.paramValue = parseInt(paramObj.paramValue);
    }
  }

  isInteger(paramId: any) {
    if (
      paramId == 5 ||
      paramId == 7 ||
      paramId == 8 ||
      paramId == 12 ||
      paramId == 13 ||
      paramId == 21 ||
      paramId == 24
    ) {
      return true;
    }
    return false;
  }

  goalTypeChanged(selected: IHaloDropDown | null, goalTypeControls: any) {
    this.selectedGoalType = selected;
    this.selectedGoalTypeDetails = this.cardioParamDef.cardioParamDef.find(
      (val: any) => val.paramId === String(selected?.value)
    );

    goalTypeControls.forEach((element: any) => {
      if (Number(element.paramId) !== selected?.value) {
        element.isShowControl = false;
      } else {
        element.isShowControl = true;
      }
    });

    if (
      Number(this.workoutObj.workoutId) === 1 ||
      Number(this.workoutObj.workoutId) === 3 ||
      Number(this.workoutObj.workoutId) === 4 ||
      Number(this.workoutObj.workoutId) === 5 ||
      Number(this.workoutObj.workoutId) === 14
    ) {
      this.formControls.nonGoalTypeControls.forEach((element: any) => {
        if (this.selectedGoalTypeDetails.paramId === '6' && element.paramId === '19') {
          element.isShowControl = true;
        } else if (this.selectedGoalTypeDetails.paramId !== '6' && element.paramId === '19') {
          element.isShowControl = false;
        }
      });
    }

    if (
      Number(selected?.value) === 21 &&
      Number(this.selectionInfo.activityId) === 16 &&
      (Number(this.workoutObj.workoutId) === 1004 ||
        Number(this.workoutObj.workoutId) === 1 ||
        Number(this.workoutObj.workoutId) === 2 ||
        Number(this.workoutObj.workoutId) === 3 ||
        Number(this.workoutObj.workoutId) === 4 ||
        Number(this.workoutObj.workoutId) === 5 ||
        Number(this.workoutObj.workoutId) === 7 ||
        Number(this.workoutObj.workoutId) === 8)
    ) {
      this.showPowermillGoalTypeClimbToggle = true;
    } else {
      this.showPowermillGoalTypeClimbToggle = false;
    }
  }

  validatePace(e: any, currentValue: string) {
    var regex = new RegExp('[0-9]');
    var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    let paceTimeParamIndex: number = this.cardioParamDef.cardioParamDef.findIndex(
      (x: { paramId: string }) => x.paramId == '19'
    );
    if (regex.test(str)) {
      this.cardioParamDef.cardioParamDef[paceTimeParamIndex].valid = true;
      return true;
    }
    if (e.charCode == 58 && !currentValue.includes(':')) {
      this.cardioParamDef.cardioParamDef[paceTimeParamIndex].valid = true;
      return true;
    }
    e.preventDefault();
    return false;
  }

  timeToSeconds(val: string) {
    let splitIndex = val.indexOf(':');
    let second = val.substring(splitIndex + 1, val.length);
    if (second.length === 1) {
      second = '0' + second;
    }
    return Number(val.substring(0, splitIndex)) * 60 + Number(second);
  }

  secondsToTime(val: number) {
    let second: string = (val % 60).toString();
    if (Number(second) < 10) {
      second = '0' + second;
    }
    return Math.floor(val / 60) + ':' + second;
  }

  stepsAndFloorConversionDefaultValue(stepsOrFloor: string, goalType: any) {
    let defaultValue = 0;
    if (stepsOrFloor == 'step') {
      defaultValue = goalType.defaultValue;
    } else if (stepsOrFloor == 'floor') {
      let floors = goalType.defaultValue / 17;
      let remainingSteps = goalType.defaultValue % 17;
      defaultValue = remainingSteps >= 9 ? floors + 1 : floors;
    }
    return defaultValue;
  }

  getMinMaxValueByStepsAndFloor(stepsOrFloor: string, goalType: any) {
    let data = { minValue: 0, maxValue: 0 };
    if (stepsOrFloor == 'steps') {
      data.minValue = goalType.minValue;
      data.maxValue = goalType.maxvalue;
    } else if (stepsOrFloor == 'floor') {
      data.minValue = goalType.minValue / 17;
      data.maxValue = goalType.maxValue / 17;
    }
    return data;
  }

  terrainTypeChanged(selected: IHaloDropDown, nonGoalTypeControls: any) {
    this.terrainType = Number(selected.value);
    nonGoalTypeControls.forEach((element: any) => {
      element.isShowControl = this.showControls(element);
      if (this.isTerrainTypeControl(element.paramId)) {
        element.defaultValue = this.terrainType;
      }
    });

    if (
      !this.isSe4Console() &&
      Number(this.terrainType) === 1 &&
      Number(this.selectionInfo.activityId) === 16 &&
      (Number(this.workoutObj.workoutId) === 1001 ||
        Number(this.workoutObj.workoutId) === 1003 ||
        Number(this.workoutObj.workoutId) === 1006)
    ) {
      this.showPowermillTerrainFlatToggle = true;
      this.powermillTerrainFlatIsSpeed = '14';
      this.powermillTerrainControlPrepare(this.powermillTerrainFlatIsSpeed);
    } else {
      this.showPowermillTerrainFlatToggle = false;
      this.powermillTerrainFlatIsSpeed = '12';
      this.powermillTerrainControlPrepare(this.powermillTerrainFlatIsSpeed);
    }
  }

  powermillTerrainControlPrepare(paramId: string) {
    this.formControls.nonGoalTypeControls.forEach((val: any) => {
      if (val.paramId === '14' || val.paramId === '12') {
        if (val.paramId === paramId) {
          val.isShowControl = true;
        } else {
          if (val.hasOwnProperty('isHighVoltage') || Number(this.selectionInfo.activityId) === 16) {
            val.isShowControl = false;
          }
        }
      }
    });
  }

  isTerrainTypeControl(paramId: any) {
    if (Number(paramId) === 9 || Number(paramId) === 40 || Number(paramId) === 41) {
      return true;
    }
    return false;
  }

  prepareIntervalMin() {
    let minArr = [] as any;
    for (let j = 0; j <= 30; j++) {
      let disp;
      if (j < 10) {
        disp = '0' + j;
      }
      minArr[j] = { value: j < 10 ? disp : j.toString(), text: j < 10 ? disp + ' Min' : j.toString() + ' Min' };
    }
    return minArr;
  }

  prepareIntervalSec(intervalMin?: string) {
    let secArr = [] as any;
    let initialValue = intervalMin === '00' ? 30 : 0;
    for (let j = initialValue; j < 60; j++) {
      let disp;
      if (j < 10) {
        disp = '0' + j;
      }
      secArr[j] = { value: j < 10 ? disp : j.toString(), text: j < 10 ? disp + ' Sec' : j.toString() + ' Sec' };
    }
    return secArr;
  }

  prepareIntervalWorkoutParams() {
    let intervalWorkoutParams = [] as any;

    if (this.mylesTreadEquipment != 'undefined' && this.intervalWorkoutType == '18') {
      if (typeof this.workoutObj.modelId == 'undefined') {
        if (Number(this.mylesTreadEquipment) == 0 || Number(this.mylesTreadEquipment) == 2) {
          this.intTypeModelId = '158';
        } else {
          this.intTypeModelId = '159';
        }
      } else {
        this.intTypeModelId = this.workoutObj.modelId;
      }
    }

    this.formControls.intervalControls.forEach((val: any) => {
      if (this.workoutObj.workoutId == 18 && val.paramId == 14) {
        val.step = 0.1;
        intervalWorkoutParams.push(val);
      } else if (this.workoutObj.workoutId == 19 && val.paramId == 13) {
        val.step = 1;
        intervalWorkoutParams.push(val);
      } else if (this.workoutObj.workoutId == 20 && val.paramId == 12) {
        val.step = 1;
        intervalWorkoutParams.push(val);
      } else if (
        this.workoutObj.workoutId == 1005 &&
        this.intervalWorkoutType == '18' &&
        val.paramId == 14 &&
        val.intervalId == 18
      ) {
        if (
          (this.selectionInfo.activityId == 28 &&
            this.intTypeModelId == '158' &&
            val.paramId == 14 &&
            typeof val.isHighVoltage != 'undefined' &&
            val.isHighVoltage == 'true') ||
          (this.selectionInfo.activityId == 28 &&
            this.intTypeModelId == '159' &&
            val.paramId == 14 &&
            typeof val.isHighVoltage == 'undefined')
        ) {
        } else {
          val.step = 0.1;
          let paramIndex = intervalWorkoutParams.findIndex(
            (sVal: any) => sVal.intervalId === val.intervalId && sVal.paramId === val.paramId
          );
          if (paramIndex > -1) {
            intervalWorkoutParams.splice(paramIndex, 1);
            intervalWorkoutParams.push(val);
          } else {
            intervalWorkoutParams.push(val);
          }
        }
      } else if (
        this.workoutObj.workoutId == 1005 &&
        this.intervalWorkoutType == '19' &&
        val.paramId == 13 &&
        val.intervalId == 19
      ) {
        val.step = 1;
        intervalWorkoutParams.push(val);
      } else if (
        this.workoutObj.workoutId == 1005 &&
        this.intervalWorkoutType == '18' &&
        val.paramId == 12 &&
        val.intervalId == 1
        ) {
          val.step = 1;
          intervalWorkoutParams.push(val);
        } else if (
        this.workoutObj.workoutId == 1005 &&
        this.intervalWorkoutType == '20' &&
        val.paramId == 12 &&
        val.intervalId == 20
      ) {
        val.step = 1;
        intervalWorkoutParams.push(val);
      }
      if (this.workoutObj.workoutId == 18 && this.selectionInfo.activityId == 1 && val.paramId == 11) {
        val.step = 0.5;
        intervalWorkoutParams.push(val);
      }
      if (this.workoutObj.workoutId == 18 && this.selectionInfo.activityId == 28 && val.paramId == 11) {
        val.step = 0.5;
        intervalWorkoutParams.push(val);
      }
      if (
        this.workoutObj.workoutId == 1005 &&
        this.intervalWorkoutType == '18' &&
        this.selectionInfo.activityId == 1 &&
        val.paramId == 11 &&
        val.intervalId == 18
      ) {
        val.step = 0.5;
        intervalWorkoutParams.push(val);
      }
      if (
        this.workoutObj.workoutId == 1005 &&
        this.intervalWorkoutType == '18' &&
        this.selectionInfo.activityId == 28 &&
        val.paramId == 11 &&
        val.intervalId == 18
      ) {
        val.step = 0.5;
        intervalWorkoutParams.push(val);
      }
      if (this.workoutObj.workoutId == 1011 && val.paramId == 14) {
        intervalWorkoutParams.push(val);
      }
    });
    const isDiscoverSE4OrIntegritySE4 = this.selectionInfo.consoleObj.consoleType === 'hal' || this.selectionInfo.consoleObj.consoleType === 'falco';
    const isPowerMills = this.selectionInfo.activityId === '16';

    const needToSkipReordering = isDiscoverSE4OrIntegritySE4 && isPowerMills;
    if (this.workoutObj.workoutId == 1005 && this.intervalWorkoutType == '18' && !needToSkipReordering) {
      let reorderedIntervalWorkoutParams: any = [];
      intervalWorkoutParams.forEach((value: any) => {
        if (value.paramId == 14) {
          reorderedIntervalWorkoutParams[0] = value;
        } else if (value.paramId == 11) {
          reorderedIntervalWorkoutParams[1] = value;
        }
      });
      intervalWorkoutParams = reorderedIntervalWorkoutParams;
    }
    return intervalWorkoutParams;
  }

  intervalWorkoutConversion(intervalWorkoutType: string, event: any) {
    if (this.intervalWorkoutType !== intervalWorkoutType) {
      if (this.intervalParamList.length > 0) {
        this.selectedToggleToReset = intervalWorkoutType;
        event.preventDefault();
        this.showUnsavedModal = true;
      } else {
        this.intervalWorkoutType = intervalWorkoutType;
        this.intervalWorkoutParams = this.prepareIntervalWorkoutParams();
        let temp = this.formControls.intervalControls.filter(
          (val: any) => val.intervalId === String(this.intervalWorkoutType)
        );
        this.intervalSelectedTypeControls = temp.filter(
          (control: any) =>
            control.isShowControl &&
            this.workoutObj.workoutId == 1005 &&
            Number(intervalWorkoutType) == 19 &&
            control.paramId == '14' &&
            control.intervalId == '19'
        );
        this.intervalParamList = [];
      }
    }
  }

  checkIntervalExists(intervalWorkoutType: string) {
    let status = false;
    if (this.cardioParamDef) {
      if (this.cardioParamDef.intervals.filter((val: any) => val.intervalId === intervalWorkoutType).length > 0) {
        status = true;
      } else {
        status = false;
      }
    }
    return status;
  }

  checkCardioParamExists(paramId: string) {
    let status = false;
    if (this.cardioParamDef) {
      if (this.cardioParamDef.cardioParamDef.filter((val: any) => val.paramId === paramId).length > 0) {
        status = true;
      } else {
        status = false;
      }
    }
    return status;
  }

  intervalMinChanged(selected: any) {
    if (this.selectedIntervalMin !== selected.value) {
      this.selectedIntervalMin = selected ? selected.value : null;
      let newArray = [] as any;

      if (this.selectedIntervalMin !== '00') {
        this.intervalSecArrForOneMin.forEach((ele: any) => {
          newArray.push({ value: ele.value, text: ele.text });
        });
        this.intervalSecArr = newArray;
        this.selectedIntervalSec = '00';
      } else {
        this.intervalSecArrForZeroMin.forEach((ele: any) => {
          newArray.push({ value: ele.value, text: ele.text });
        });
        this.intervalSecArr = newArray;
        this.selectedIntervalSec = '30';
      }
    }
    this.isAllowAddInterval =
      this.totalRemainingIntervalSec - (Number(this.selectedIntervalMin) * 60 + Number(this.selectedIntervalSec)) >= 0
        ? true
        : false;
  }

  intervalSecChanged(selected: any) {
    this.selectedIntervalSec = selected ? selected.value : null;
    this.isAllowAddInterval =
      this.totalRemainingIntervalSec - (Number(this.selectedIntervalMin) * 60 + Number(this.selectedIntervalSec)) >= 0
        ? true
        : false;
  }

  intervalTableMinChanged(selected: any, control: any) {
    if (control.selectedIntervalMin !== selected.value) {
      control.selectedIntervalMin = selected ? selected.value : null;
      let newArray = [] as any;

      if (control.selectedIntervalMin !== '00') {
        this.intervalSecArrForOneMin.forEach((ele: any) => {
          newArray.push({ value: ele.value, text: ele.text });
        });
        control.intervalSecArr = newArray;
        control.selectedIntervalSec = '00';
      } else {
        this.intervalSecArrForZeroMin.forEach((ele: any) => {
          newArray.push({ value: ele.value, text: ele.text });
        });
        control.intervalSecArr = newArray;
        control.selectedIntervalSec = '30';
      }
    }

    let totalSec = 0;
    this.intervalParamList.forEach((ele: any) => {
      totalSec += Number(ele.selectedIntervalMin) * 60 + Number(ele.selectedIntervalSec);
    });
    let status = this.currentIntervalMin * 60 >= totalSec ? true : false;
    if (!status) {
      this.intervalParamList.forEach((ele: any) => {
        if (ele.isEdited) {
          ele.valid = false;
        }
      });
    } else {
      this.intervalParamList.forEach((ele: any) => {
        if (ele.isEdited) {
          ele.valid = true;
        }
      });
    }
  }

  intervalTableSecChanged(selected: any, control: any) {
    control.selectedIntervalSec = selected ? selected.value : null;
    let totalSec = 0;
    this.intervalParamList.forEach((ele: any) => {
      totalSec += Number(ele.selectedIntervalMin) * 60 + Number(ele.selectedIntervalSec);
    });
    control.valid = this.currentIntervalMin * 60 >= totalSec ? true : false;
  }

  addInterval() {
    if (this.selectedIntervalMin && this.selectedIntervalSec) {
      let obj: any = {
        intervalMinArr: this.intervalMinArr,
        intervalSecArr: this.intervalSecArr,
        selectedIntervalMin: this.selectedIntervalMin,
        selectedIntervalSec: this.selectedIntervalSec,
        isEdited: false,
        valid: true,
      };

      if (this.workoutObj.workoutId == 1011) {
        this.intervalWorkoutParams[0].defaultValue = this.intervalMigrosType;
        this.intervalWorkoutParams = JSON.parse(JSON.stringify(this.intervalWorkoutParams));
      } else {
        this.intervalWorkoutParams = this.updateSpeedInclineCompareChart(this.intervalWorkoutParams);
      }

      obj['paramIntervalInfo'] = JSON.parse(JSON.stringify(this.intervalWorkoutParams));
      obj['previousIntervalInfo'] = JSON.parse(JSON.stringify(obj));
      this.intervalParamList.push(obj);
      this.updateRemainingInterval();
      this.intervalParamListEventEmit.emit(this.intervalParamList);
    }
  }

  updateSpeedInclineCompareChart(intervalWorkoutParams: any) {
    let obj = JSON.parse(JSON.stringify(intervalWorkoutParams));
    let inclineParam = obj.find((val: any) => val.paramId === '11');
    let speedParam = obj.find((val: any) => val.paramId === '14');
    if (inclineParam && speedParam) {
      obj.forEach((ele: any) => {
        if (ele.paramId === '11') {
          let inclineMaxValue = Number(inclineParam?.maxValue);
          let val = (ele.defaultValue / inclineMaxValue) * 100;
          ele.lineChartPercent = 100 - val;
        } else if (ele.paramId === '14') {
          let speedMaxValue = Number(speedParam?.maxValue);
          let val = (ele.defaultValue / speedMaxValue) * 100;
          ele.lineChartPercent = 100 - val;
        }
      });
    }

    let levelParam = obj.find((val: any) => val.paramId === '12');
    let targetHeartRateParam = obj.find((val: any) => val.paramId === '13');
    if (levelParam || targetHeartRateParam) {
      obj.forEach((ele: any) => {
        if (ele.paramId === '12') {
          let levelMaxValue = Number(levelParam?.maxValue);
          let val = (ele.defaultValue / levelMaxValue) * 100;
          ele.lineChartPercent = 100 - val;
        } else if (ele.paramId === '13') {
          let targetHeartRateMaxValue = Number(targetHeartRateParam?.maxValue);
          let val = (ele.defaultValue / targetHeartRateMaxValue) * 100;
          ele.lineChartPercent = 100 - val;
        }
      });
    }
    return obj;
  }

  onPositiveConfirmationUnsavedModal(event: any) {
    this.showUnsavedModal = false;
    this.intervalWorkoutType = this.selectedToggleToReset;
    this.intervalWorkoutParams = this.prepareIntervalWorkoutParams();
    let temp = this.formControls.intervalControls.filter(
      (val: any) => val.intervalId === String(this.intervalWorkoutType)
    );
    this.intervalSelectedTypeControls = temp.filter(
      (control: any) =>
        control.isShowControl &&
        this.workoutObj.workoutId == 1005 &&
        Number(this.intervalWorkoutType) == 19 &&
        control.paramId == '14' &&
        control.intervalId == '19'
    );
    this.intervalParamList = [];
    this.totalRemainingIntervalSec = this.currentIntervalMin * 60;
    this.remainingTimeEventEmit.emit({
      totalRemainingIntervalSec: this.totalRemainingIntervalSec,
      totalAppliedIntervalSec: 0,
      formControls: this.formControls,
    });
  }

  closeUnsavedModal(event: any) {
    this.showUnsavedModal = false;
  }

  onIntevalRowClick(control: any) {
    if (!control.isEdited) {
      control.isEdited = true;
    }
  }

  onIntevalRowActionClick(e: Event, control: any, index: any, action: string) {
    if (action === 'undo') {
      let previousIntervalInfo = JSON.parse(JSON.stringify(control['previousIntervalInfo']));
      control.selectedIntervalMin = control['previousIntervalInfo'].selectedIntervalMin;
      control.selectedIntervalSec = control['previousIntervalInfo'].selectedIntervalSec;
      control.paramIntervalInfo = JSON.parse(JSON.stringify(control['previousIntervalInfo'].paramIntervalInfo));
      control.previousIntervalInfo = previousIntervalInfo;
      control.isEdited = false;
      control.valid = true;
    } else if (action === 'save') {
      control.paramIntervalInfo = this.updateSpeedInclineCompareChart(control.paramIntervalInfo);
      let obj = {
        selectedIntervalMin: control.selectedIntervalMin,
        selectedIntervalSec: control.selectedIntervalSec,
        paramIntervalInfo: control.paramIntervalInfo,
        isEdited: false,
      } as any;
      control.isEdited = false;
      control.valid = true;
      control.previousIntervalInfo = JSON.parse(JSON.stringify(obj));
    } else {
      this.totalAppliedIntervalSec =
        this.totalAppliedIntervalSec - (Number(control.selectedIntervalMin) * 60 + Number(control.selectedIntervalSec));
      this.intervalParamList.splice(index, 1);
      this.intervalParamListEventEmit.emit(this.intervalParamList);
    }

    this.updateRemainingInterval();
    e.stopPropagation();
  }

  goalValueFocus(control: any) {
    this.currentIntervalMin = control.defaultValue;
  }

  goalValueChanged(control: any) {
    if (
      !control.defaultValue ||
      isNaN(control.defaultValue) ||
      parseFloat(control.defaultValue) < parseFloat(control.minValue) ||
      parseFloat(control.defaultValue) > parseFloat(control.maxValue)
    ) {
      control.defaultValue = control.minValue;
    } else {
      if (control.paramId === '7') {
        if (
          this.workoutObj.workoutId == 18 ||
          this.workoutObj.workoutId == 19 ||
          this.workoutObj.workoutId == 20 ||
          this.workoutObj.workoutId == 1005 ||
          this.workoutObj.workoutId == 1011
        ) {
          let defaultIntervalSec = control.defaultValue * 60;
          let totalSec = 0;
          this.intervalParamList.forEach((ele: any) => {
            totalSec += Number(ele.selectedIntervalMin) * 60 + Number(ele.selectedIntervalSec);
          });

          if (defaultIntervalSec >= totalSec) {
            this.totalRemainingIntervalSec = defaultIntervalSec - totalSec;
            this.isAllowAddInterval =
              this.totalRemainingIntervalSec -
                (Number(this.selectedIntervalMin) * 60 + Number(this.selectedIntervalSec)) >=
              0
                ? true
                : false;
            this.remainingTimeEventEmit.emit({
              totalRemainingIntervalSec: this.totalRemainingIntervalSec,
              totalAppliedIntervalSec: this.totalAppliedIntervalSec,
              formControls: this.formControls,
            });
            this.currentIntervalMin = control.defaultValue;
          } else {
            control.defaultValue = this.currentIntervalMin;
          }
        }
      }
    }
  }

  updateRemainingInterval() {
    let totalSec = 0;
    this.intervalParamList.forEach((ele: any) => {
      totalSec += Number(ele.selectedIntervalMin * 60) + Number(ele.selectedIntervalSec);
    });
    this.totalAppliedIntervalSec = totalSec;

    this.totalRemainingIntervalSec = this.currentIntervalMin * 60 - this.totalAppliedIntervalSec;
    if (this.totalRemainingIntervalSec >= 0) {
      this.isAllowAddInterval =
        this.totalRemainingIntervalSec - (Number(this.selectedIntervalMin) * 60 + Number(this.selectedIntervalSec)) >= 0
          ? true
          : false;
      this.remainingTimeEventEmit.emit({
        totalRemainingIntervalSec: this.totalRemainingIntervalSec,
        totalAppliedIntervalSec: this.totalAppliedIntervalSec,
        formControls: this.formControls,
      });
    }
  }

  inputValueChanged(control: any) {
    if (
      !control.defaultValue ||
      isNaN(control.defaultValue) ||
      parseFloat(control.defaultValue) < parseFloat(control.minValue) ||
      parseFloat(control.defaultValue) > parseFloat(control.maxValue)
    ) {
      control.defaultValue = control.minValue;
    }
  }

  async onPositiveConfirmationToProceedSaveCustomWorkout(status: boolean) {
    this.showRemainingTimeModal = false;
    let payload = this.preparePayload();
    this.loader.startProcess();
    let resp: any = await this.workoutService.saveWorkOut(payload);
    this.loader.endProcess();
    if (this.isEditWorkout && this.sourceFrom === 'workoutTemplate') {
      this.backToWorkoutTemplateListingEventEmit.emit(payload);
    } else {
      this.backToWorkoutListingEventEmit.emit();
    }
  }

  closeRemaingTimeConfirmationModal(status: boolean) {
    this.showRemainingTimeModal = false;
  }

  replaceValueAsHTMLOnTranslatedTextWithoutTrust(
    translateKey: string,
    workOutType: string,
    minValue: string,
    maxValue: string
  ) {
    let message = this.commonUtil.replaceValueAsHTMLOnTranslatedText(translateKey, [workOutType, minValue, maxValue]);
    return message;
  }

  onInputKeyPress(event: KeyboardEvent, control: any) {
    if (control.paramId !== '14' && control.paramId !== '11') {
      let isDecimalValueAllow = false;
      if (
        control.minValue - Math.floor(control.minValue) !== 0 ||
        control.maxValue - Math.floor(control.maxValue) !== 0
      ) {
        isDecimalValueAllow = true;
      }
      if (!isDecimalValueAllow && event.keyCode === 46) {
        event.preventDefault();
      }
    }
  }

  ngOnDestroy() {
    this.resetActionButtonEventEmit.emit();
  }
}
